export enum LayoutList {
  'SQUARE' = 'square',
  'CIRCLE' = 'circle',
  'SQUARE3H' = 'square-3h',
  'SQUARE1H2S' = 'square-1h2s',
  'SQUARE4S' = 'square-4s',
  'SQUARE1V3S' = 'square-1v3s',
}
